var styles = {"header":"navkit__Headline__header","isGapless":"navkit__Headline__isGapless","isUppercase":"navkit__Headline__isUppercase"};

export { styles as default };
